import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AlertType } from './alert';

@Component({
  selector: 'ps-ui-alert',
  template: `
    <div class="alert alert-{{ type }}" role="alert">
      <ng-template [ngIf]="message">
        <span>{{ message }}</span>
      </ng-template>
      <ng-content select="[psUiAlertContent], ps-ui-alert-content"></ng-content>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent {
  @Input()
  public message: string = '';

  @Input()
  public type: AlertType = 'info';
}
